module.exports = __webpack_public_path__ + "img/oval-curr-reading.44d0decf.png";